import { render, staticRenderFns } from "./LlegadaContacto.vue?vue&type=template&id=9a3dc52c&scoped=true"
import script from "./LlegadaContacto.vue?vue&type=script&lang=js"
export * from "./LlegadaContacto.vue?vue&type=script&lang=js"
import style0 from "./LlegadaContacto.vue?vue&type=style&index=0&id=9a3dc52c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3dc52c",
  null
  
)

export default component.exports